/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { MdAccessTime } from 'react-icons/md';
import {
  convertTravelTime,
  formatTimeStringAmPmFormat,
  getConnectingTime,
  getTerminalNumberwithTerminal,
} from '../../shared/helper-utils/appUtils';
import { getFlightTicketApi } from '../../api/flightApi';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import AppLink from '../../shared/components/app-link/AppLink';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import { useAppContext } from '../../saas/AppConfigWrapper';
import { AIRLINE_NAMES_FOR_CARRIER_CODE } from '../../shared/constants/FlightCarrierNames';

function FlightBookingDetailsSidebar({ txid, onClose, isOpen, flightRecord }) {
  const { appConfig } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [hasTicket, setHasTicket] = useState(undefined);
  const flightTransactionRef = useRef(undefined);
  const flightRecordRef = useRef(undefined);
  const flightSectorsRef = useRef([]);
  const onwardSectorsRef = useRef([]);
  const returnSectorsRef = useRef([]);
  const passengerRef = useRef([]);
  const onwardPaxRef = useRef([]);
  const returnPaxRef = useRef([]);

  const getTicketDetails = async (tx) => {
    setIsLoading(true);
    const res = await getFlightTicketApi(tx);
    if (res && res.ApiStatus && res.ApiStatus.Status === 'OK') {
      const { FlightInvoice } = res.ApiStatus.Result.FullFlightDetails;
      flightTransactionRef.current = FlightInvoice;
      flightRecordRef.current = FlightInvoice.FlightRecord;
      let { SectorRecord } = FlightInvoice.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      flightSectorsRef.current = SectorRecord;
      const onwardSecotors = flightSectorsRef.current.filter(
        (x) => x.FlightType.toLowerCase() === 'onward',
      );
      onwardSectorsRef.current = onwardSecotors;
      const returnSectors = flightSectorsRef.current.filter(
        (x) => x.FlightType.toLowerCase() === 'return',
      );

      returnSectorsRef.current = returnSectors;
      let { PassengerRecord } = FlightInvoice.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];

      passengerRef.current = PassengerRecord;

      let onwardList = [];
      onwardList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      onwardPaxRef.current = onwardList;
      let returnList = [];
      returnList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 2,
      );
      returnPaxRef.current = returnList;
      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: '',
        description: 'Failed to load ticket details',
      });
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getTicketDetails(txid);
  }, [txid]);
  return (
    <div>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}

      <AppSidebar
        onHideSidebar={onClose}
        sidebarTitle={
          <div className="d-flex gap-3">
            <div className="d-flex flex-column">
              <span className="fs-10">PNR</span>
              <span className="fs-14 fw-600">
                {flightRecord.AirlinePnr.split(',')[0]}{' '}
                {flightRecord.AirlinePnr.split(',')[1]
                  ? `,${flightRecord.AirlinePnr.split(',')[1]}`
                  : ''}
              </span>
            </div>
            <div className="d-flex flex-column">
              <span className="fs-10">Booking ID</span>
              <span className="fs-14 fw-600">{flightRecord.Txid}</span>
            </div>
          </div>
        }
        modalClassName="flight-booking-details-sidebar"
      >
        {isLoading && hasTicket === undefined && <AppPreviewLoader />}
        {isOpen && hasTicket && (
          <Row className="spacing-0 flight-cancellation-page">
            <Col lg={8} md={8} sm={6} xs={12}>
              <div className="flight-cancellation-page_container_card">
                <div className="flight-cancellation-page_container_card_title fw-600">
                  Flight Details
                </div>
                <div className="flight-cancellation-page_container_card_content">
                  {returnSectorsRef.current.length > 0 && (
                    <div>Onward Journey</div>
                  )}
                  <div>
                    {onwardSectorsRef.current.map((sector, secIndex) => {
                      const finalDestination =
                        onwardSectorsRef.current[
                          onwardSectorsRef.current.length - 1
                        ].Destination;
                      return (
                        <div key={secIndex}>
                          <div className="d-flex gap-2 flex-wrap align-items-center">
                            <div>
                              <AppFlightLogo
                                carrier={sector.Carrier.substring(0, 2)}
                                className="vertical-bottom"
                                width="30px"
                                height="30px"
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <span className="fs-14 fw-600">
                                {
                                  AIRLINE_NAMES_FOR_CARRIER_CODE[
                                    sector.Carrier.substring(0, 2)
                                  ]
                                }
                              </span>
                              <span className="fs-12 fw-300">
                                {sector.Carrier.substring(0, 2)}-
                                {sector.FlightNumber}
                              </span>
                            </div>
                            <div className="d-flex flex-column">
                              <span className="fs-10">Cabin Class</span>
                              <span className="text-capitalize fs-12">
                                {flightRecordRef.current.CabinClass}
                              </span>
                            </div>
                          </div>
                          <div className="selected-flight-details__flight-leg_departure my-3">
                            <div className="d-flex align-items-center">
                              <img
                                src="/images/others/flight-details-line.svg"
                                alt=""
                                style={{ height: '50px' }}
                              />
                            </div>
                            <div className="d-flex flex-column">
                              <span className="dark-grey-color fs-14 fw-600">
                                {`${
                                  sector.Origin
                                } | ${formatTimeStringAmPmFormat(
                                  sector.DepartureTime,
                                )} `}
                                <span className="fs-12 fw-300">
                                  {getTerminalNumberwithTerminal(
                                    sector?.AirportTerminal?.split(',')[0],
                                  )}
                                </span>
                              </span>
                              <span className=" fs-12 fw-300">
                                {sector.OriginAirportFullname}
                              </span>
                              <span className="fs-12 grey-color">
                                Duration:{' '}
                                {convertTravelTime(sector.SectorDuration)}
                              </span>
                              <span className="dark-grey-color fs-14 fw-600">
                                {`${
                                  sector.Destination
                                } | ${formatTimeStringAmPmFormat(
                                  sector.ArrivalTime,
                                )} `}
                                <span className=" fs-12 fw-300">
                                  {getTerminalNumberwithTerminal(
                                    sector?.AirportTerminal?.split(',')[1],
                                  )}
                                </span>
                              </span>
                              <span className=" fs-12 fw-300">
                                {sector.DestinationAirportFullname}
                              </span>
                            </div>
                          </div>
                          {sector.Destination !== finalDestination && (
                            <div className="selected-flight-details__flight-leg_layover py-1 my-2">
                              <MdAccessTime />
                              <span className="selected-flight-details__flight-leg_layover__location ms-1">
                                {getConnectingTime(
                                  sector.ArrivalTime,
                                  sector.ArrivalDate,
                                  onwardSectorsRef.current[secIndex + 1]
                                    .DepartureTime,
                                  onwardSectorsRef.current[secIndex + 1]
                                    .JourneyDate,
                                )}{' '}
                                layover in {sector.DestinationAirportFullname}
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  {returnSectorsRef.current.length > 0 && (
                    <>
                      <div>Return Journey</div>
                      <div>
                        {returnSectorsRef.current.map((sector, secIndex) => {
                          const finalDestination =
                            returnSectorsRef.current[
                              returnSectorsRef.current.length - 1
                            ].Destination;
                          return (
                            <div key={secIndex}>
                              <div className="d-flex gap-2 flex-wrap align-items-center">
                                <div>
                                  <AppFlightLogo
                                    carrier={sector.Carrier.substring(0, 2)}
                                    className="vertical-bottom"
                                    width="30px"
                                    height="30px"
                                  />
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="fs-14 fw-600">
                                    {
                                      AIRLINE_NAMES_FOR_CARRIER_CODE[
                                        sector.Carrier.substring(0, 2)
                                      ]
                                    }
                                  </span>
                                  <span className="fs-12 fw-300">
                                    {sector.Carrier.substring(0, 2)}-
                                    {sector.FlightNumber}
                                  </span>
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="fs-10">Cabin Class</span>
                                  <span className="text-capitalize fs-12">
                                    {flightRecordRef.current.CabinClass}
                                  </span>
                                </div>
                              </div>
                              <div className="selected-flight-details__flight-leg_departure my-3">
                                <div className="d-flex align-items-center">
                                  <img
                                    src="/images/others/flight-details-line.svg"
                                    alt=""
                                    style={{ height: '50px' }}
                                  />
                                </div>
                                <div className="d-flex flex-column">
                                  <span className="dark-grey-color fs-14 fw-600">
                                    {`${formatTimeStringAmPmFormat(
                                      sector.DepartureTime,
                                    )} `}
                                    <span className="fs-12 fw-300">
                                      {getTerminalNumberwithTerminal(
                                        sector?.AirportTerminal?.split(',')[0],
                                      )}
                                    </span>
                                  </span>
                                  <span className=" fs-12 fw-300">
                                    {sector.OriginAirportFullname}
                                  </span>
                                  <span className="fs-12 grey-color">
                                    Duration:{' '}
                                    {convertTravelTime(sector.SectorDuration)}
                                  </span>
                                  <span className="dark-grey-color fs-14 fw-600">
                                    {`${formatTimeStringAmPmFormat(
                                      sector.ArrivalTime,
                                    )} `}
                                    <span className=" fs-12 fw-300">
                                      {getTerminalNumberwithTerminal(
                                        sector?.AirportTerminal?.split(',')[1],
                                      )}
                                    </span>
                                  </span>
                                  <span className=" fs-12 fw-300">
                                    {sector.DestinationAirportFullname}
                                  </span>
                                </div>
                              </div>
                              {sector.Destination !== finalDestination && (
                                <div className="selected-flight-details__flight-leg_layover py-1 my-2">
                                  <MdAccessTime />
                                  <span className="selected-flight-details__flight-leg_layover__location ms-1">
                                    {getConnectingTime(
                                      sector.ArrivalTime,
                                      sector.ArrivalDate,
                                      returnSectorsRef.current[secIndex + 1]
                                        .DepartureTime,
                                      returnSectorsRef.current[secIndex + 1]
                                        .JourneyDate,
                                    )}{' '}
                                    layover in{' '}
                                    {sector.DestinationAirportFullname}
                                  </span>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col lg={4} md={4} sm={6} xs={12}>
              <div className="d-flex justify-content-between flight-cancellation-page_container_card">
                <div className="d-flex flex-column align-items-start">
                  <span className="fs-12 fw-300">Booking Status</span>
                  <span className="text-capitalize fs-14 fw-500">
                    {flightRecordRef.current.BookingStatus}
                  </span>
                </div>
                <div className="d-flex flex-column align-items-end">
                  <span className="fs-12 fw-300">PNR</span>
                  <span className="text-capitalize fs-14 fw-500">
                    {flightRecordRef.current.AirlinePnr}
                  </span>
                </div>
              </div>
              <div className="flight-cancellation-page_container_card d-flex justify-content-between align-items-center">
                <span className="fs-12 fw-300">Total Paid</span>
                <span className="fs-14 fw-600">
                  {appConfig?.appCurrency}{' '}
                  {flightRecordRef.current.FareQuoteAmount}
                </span>
              </div>
              <div className="flight-cancellation-page_container_card">
                <table className="w-100">
                  <tbody>
                    <tr className="fs-12 fw-300">
                      <td>Name</td>
                      <td className="text-end">Sector</td>
                    </tr>
                    {onwardPaxRef.current.map((pax, paxIndex) => (
                      <tr key={paxIndex} className="fs-14 fw-500">
                        <td>
                          {pax.Title} {pax.FirstName} {pax.LastName}
                        </td>
                        <td className="text-end">
                          {flightRecordRef.current.Origin}-
                          {flightRecordRef.current.Destination}
                        </td>
                      </tr>
                    ))}
                    {returnPaxRef.current.map((pax, paxIndex) => (
                      <tr key={paxIndex} className="fs-14 fw-500">
                        <td>
                          {pax.Title} {pax.FirstName} {pax.LastName}
                        </td>
                        <td className="text-end">
                          {flightRecordRef.current.Destination}-
                          {flightRecordRef.current.Origin}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flight-cancellation-page_container_card d-flex justify-content-between align-items-center">
                <AppLink
                  linkText="E-Ticket"
                  variant="primary"
                  isLink
                  target="_blank"
                  href={`/flight/ticket/${flightRecordRef.current.Txid}`}
                />
                {flightRecordRef.current?.BookingStatus?.toLowerCase() !==
                  'cancelled' && (
                  <AppLink
                    linkText="Invoice"
                    variant="primary"
                    isLink
                    target="_blank"
                    href={`/flight/invoice/${flightRecordRef.current.Txid}`}
                  />
                )}
              </div>
              {['confirmed'].indexOf(
                flightRecordRef.current.BookingStatus.toLowerCase(),
              ) > -1 && (
                <div className="flight-cancellation-page_container_card d-flex justify-content-between align-items-center">
                  <AppLink
                    linkText="Cancel"
                    variant="primary"
                    isLink
                    target="_blank"
                    href={`/flight/cancellation/${flightRecordRef.current.Txid}`}
                  />
                  <AppLink
                    linkText="Reshedule"
                    variant="primary"
                    isLink
                    target="_blank"
                    href={`/flight/reshedule/${flightRecordRef.current.Txid}`}
                  />
                </div>
              )}
            </Col>
          </Row>
        )}
      </AppSidebar>
    </div>
  );
}

FlightBookingDetailsSidebar.propTypes = {
  txid: PropTypes.any.isRequired,
  onClose: PropTypes.any.isRequired,
  isOpen: PropTypes.any.isRequired,
  flightRecord: PropTypes.any.isRequired,
};

export default FlightBookingDetailsSidebar;
